import { ApplicationType } from '@sdir/httpclient/lib/clients/aps/application';
import React from 'react';
import { useIntl } from 'react-intl';
import { translateCertificateType } from '../../../helpers/Certificates';
import { useGetCertificateName } from '../../../services/hooks';
import { CardRow, Card } from '../../Atoms';

const CertificateSummaryCard: React.FC<{ certificate: string; type: ApplicationType }> = ({
  certificate,
  type,
}) => {
  const intl = useIntl();
  const certificateName = useGetCertificateName(certificate);

  return (
    <Card heading={intl.formatMessage({ id: 'certificate.type' })}>
      <CardRow label={intl.formatMessage({ id: 'certificate.type' })}>{certificateName}</CardRow>
      <CardRow label={intl.formatMessage({ id: 'certificate.app.type' })}>
        {translateCertificateType(type, intl)}
      </CardRow>
    </Card>
  );
};

export default CertificateSummaryCard;
